import { render, staticRenderFns } from "./SearchBank.vue?vue&type=template&id=195b096a&scoped=true"
import script from "./SearchBank.vue?vue&type=script&lang=js"
export * from "./SearchBank.vue?vue&type=script&lang=js"
import style0 from "./SearchBank.vue?vue&type=style&index=0&id=195b096a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b096a",
  null
  
)

export default component.exports